import { formatMb } from './media';

export type MediaUsage = {
  usedBytes: number;
  limitBytes: number | null;
  pictures: number;
  recordings: number;
  pictureLimit: number | null;
  recordingLimit: number | null;
  addOn: boolean;
};

type Translate = (key: string, vars?: Record<string, string | number>) => string;

export function usageLine(u: MediaUsage, t: Translate): string {
  if (u.addOn && u.limitBytes !== null) {
    return t('Storage used: {used} of {limit} (fair use, 100 MB for each place on your plan).', { used: formatMb(u.usedBytes), limit: formatMb(u.limitBytes) });
  }
  return t('{pictures} of {pictureLimit} photos and {recordings} of {recordingLimit} recordings used. The Custom pictures and voice add-on gives you more.', {
    pictures: u.pictures,
    pictureLimit: u.pictureLimit ?? 0,
    recordings: u.recordings,
    recordingLimit: u.recordingLimit ?? 0,
  });
}

export function usageShare(u: MediaUsage): number {
  if (u.addOn && u.limitBytes) return u.usedBytes / u.limitBytes;
  const pictures = u.pictureLimit ? u.pictures / u.pictureLimit : 0;
  const recordings = u.recordingLimit ? u.recordings / u.recordingLimit : 0;
  return Math.max(pictures, recordings);
}
